module.exports = __webpack_public_path__ + "33652414e224e7e57c1896437a75a009.svg";